module.exports = __webpack_public_path__ + "insa-report/web/locale/en-US/viewer.properties";


//////////////////
// WEBPACK FOOTER
// ./app/insa-report/web/locale/en-US/viewer.properties
// module id = 970
// module chunks = 3